enum AlertType {
  Success = 0,
  Error = 1,

  Warning = 2,
  Info = 3
}

export default AlertType;
